export const ROW_HEIGHT = 60;
export const EXPANDED_ROW_HEIGHT = 280;
